/**
 * Tabellennamen - getrennt nach Zweck.
 *
 * - `DATA_TABLE_NAMES`: die Nutzdaten. Einzige Quelle der Wahrheit fuer die
 *   Sicherung (Export, Import, Pruefsumme) und fuer die Aufzeichnung des
 *   Papierkorbs (F-45).
 * - `SYNC_TABLE_NAMES`: was synchronisiert wird - die Nutzdaten plus Kopf und
 *   Zeilen des Papierkorbs, damit Geloeschtes auf jedem Geraet
 *   wiederherstellbar ist. Der Papierkorb steht bewusst NICHT in der
 *   Sicherung; die Bytes geloeschter Anhaenge (`papierkorbDateien`) bleiben
 *   lokal und werden nie synchronisiert.
 *
 * Server-Regel: Tabellennamen nur aus Buchstaben (`/^[A-Za-z]{1,40}$/`).
 */
export const DATA_TABLE_NAMES = [
  'areas', 'events', 'tasks', 'projects', 'goals', 'lifeWheel', 'weeklyReviews',
  'habits', 'habitEntries', 'journal', 'accounts', 'envelopes', 'transactions',
  'subscriptions', 'books', 'contacts', 'resources', 'attachments', 'categories', 'savedColors', 'priorityColors',
  'subjects', 'schoolSettings', 'grades', 'studySessions', 'journalCategories', 'thoughts', 'monthlyReviews',
  'focusGoals', 'reflexionsFragen', 'terminBestaetigungen', 'listen', 'listenEintraege',
  'uebungen', 'trainingsplaene', 'planEinheiten', 'trainingsprotokolle', 'trainingsEinstellungen',
  'koerpergewicht', 'muskelgefuehl', 'sportRad',
  'lebensmittel', 'rezepte', 'speiseplan', 'planVorlagen', 'gegessen', 'getraenke', 'ernaehrungsEinstellungen',
  'tagesvorlagen', 'vorlagenEinstellungen', 'journalLayouts', 'oberflaeche',
] as const;

export type DataTableName = (typeof DATA_TABLE_NAMES)[number];

/** Papierkorb-Tabellen, die zwischen den Geraeten abgeglichen werden (F-45). */
export const PAPIERKORB_SYNC_NAMES = ['papierkorb', 'papierkorbZeilen'] as const;

export const SYNC_TABLE_NAMES = [...DATA_TABLE_NAMES, ...PAPIERKORB_SYNC_NAMES] as const;

export type SyncTableName = (typeof SYNC_TABLE_NAMES)[number];
